module.exports = {"Type":"Event","Output":true,"Fields":[{"label":"Event name","name":"speak"},{"label":"Value","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"black","BackgroundColor":"#6d6525","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Event.json
// module id = 696
// module chunks = 0